import {AUTH_USER, LOGOUT, AUTH_PENDING, AUTH_UNCONFIMED} from '../actions/auth';

const initialState = {
	user: null,
	authWait: true,
	authPending: false,
	unconfirmed: false
};

export default (state = initialState, action) => {
	switch (action.type) {
		case AUTH_USER:
			return {
				...state, user: action.user, authPending: false, authWait: false
			};
		case LOGOUT:
			return initialState;
		case AUTH_UNCONFIMED:
			return {
				user: null, authPending: false, unconfirmed: true, authWait: false
			};
		case AUTH_PENDING:
			return {...state, authPending: action.authPending, authWait: false};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/client/redux/reducers/auth.js